import { useEffect, useState } from 'react'
import { getReportDropDivisionsAPI } from '../../services/dropdown'

function UseReportDropDivisions(orgId, groupId) {
  const [options, setOptions] = useState([])
  const [rawData, setRawData] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const getData = async () => {
      setLoading(true)
      try {
        const params = { orgId }
        if (groupId) params.groupId = groupId
        const resp = await getReportDropDivisionsAPI(params)
        if (!resp) return
        if (resp.status) {
          setRawData(resp.result)
          const newData = resp.result.map((d) => ({
            value: d?.dsId,
            label: `${d?.divisionName} (${d?.division})`
          }))
          setOptions(newData)
        } else {
          setOptions([])
          setRawData([])
        }
      } finally {
        setLoading(false)
      }
    }

    if (orgId) {
      getData()
    }
  }, [orgId, groupId])

  return { options, rawData, loading }
}

export default UseReportDropDivisions
